import { Route, Routes } from 'react-router-dom';

import { FirstAccessPage } from '../pages/FirstAccessPage';
import { Login } from '../pages/Login';
import { PasswordRecovery } from '../pages/PasswordRecovery/PasswordRecovery';

export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />

      <Route path="primeiro-acesso" element={<FirstAccessPage />} />

      <Route path="recuperacao-de-senha" element={<PasswordRecovery />} />

      <Route path="/*" element={<Login />} />
    </Routes>
  );
};
